export const sortGigs = (items) =>
  [...items].sort((left, right) => {
    const leftTime = new Date(left?.date ?? 0).getTime();
    const rightTime = new Date(right?.date ?? 0).getTime();
    return leftTime - rightTime;
  });

export const toNullableString = (value) => {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const buildAuthHeaders = (token, extra = {}) =>
  token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };

export const listToInputValue = (value) => {
  if (Array.isArray(value)) {
    return value.join(", ");
  }
  if (typeof value === "string") {
    return value;
  }
  return "";
};

export const ensureNumber = (value) => {
  if (value === "" || value == null) {
    return null;
  }
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

export const toISOOrNull = (value) => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date.toISOString();
};

export const parseList = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => `${item ?? ""}`.trim()).filter(Boolean);
  }
  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }
  return [];
};

export const genreBackgrounds = {
  jazz: "https://images.unsplash.com/photo-1461784180001-7310b0ee9a26?auto=format&fit=crop&w=1200&q=60",
  soul: "https://images.unsplash.com/photo-1468151187686-26bc5cbdc6d6?auto=format&fit=crop&w=1200&q=60",
  rock: "https://images.unsplash.com/photo-1507878866276-a947ef722fee?auto=format&fit=crop&w=1200&q=60",
  pop: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=1200&q=60",
  electronic:
    "https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=1200&q=60",
  techno:
    "https://images.unsplash.com/photo-1444824775686-4185f172c44b?auto=format&fit=crop&w=1200&q=60",
  classical:
    "https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&w=1200&q=60",
  acoustic:
    "https://images.unsplash.com/photo-1485579149621-3123dd979885?auto=format&fit=crop&w=1200&q=60",
};

export const resolveGigBackground = (genres = []) => {
  const normalized = genres.map((genre) => `${genre}`.toLowerCase());
  for (const [key, imageUrl] of Object.entries(genreBackgrounds)) {
    const match = normalized.find((genre) => genre.includes(key));
    if (match) {
      return `linear-gradient(180deg, rgba(2,6,23,0.85), rgba(2,6,23,0.95)), url('${imageUrl}')`;
    }
  }
  return null;
};

export const formatPayout = (payout) => {
  if (!Number.isFinite(payout)) {
    return null;
  }
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "DKK",
      maximumFractionDigits: 0,
    }).format(payout);
  } catch (error) {
    console.error("Failed to format payout", error);
    return `${payout} DKK`;
  }
};

export const getGigCity = (gig) => (gig?.city ?? gig?.location ?? "").trim();

export const getGigPayout = (gig) => {
  const value = gig?.payout;
  if (Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string") {
    const numeric = Number(value.replace(/[^0-9.-]+/g, ""));
    return Number.isFinite(numeric) ? numeric : null;
  }
  return null;
};

export const pickRandom = (list, count) => {
  const copy = Array.isArray(list) ? [...list] : [];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, count);
};
